import { BodyText, Heading, Icon, IconSet } from '@postscript/components';
import classes from 'components/ProgressiveOnboarding/TryItYourself.module.css';
import { useUser } from 'controllers/contexts/user';
import { PROGRESSIVE_ONBOARDING_SOURCE } from 'providers/ProgressiveOnboarding/constants/constants';
import { logButtonClickEvent } from 'utils/events';

export const TryItYourself = ({
  message,
  productArea,
  workflow,
  step,
  onTryClick,
}: {
  message: string;
  productArea: string;
  workflow: string;
  step: string;
  onTryClick?: () => void;
}) => {
  const { user } = useUser();

  const handleClick = (event: React.MouseEvent) => {
    if (onTryClick) onTryClick();

    logButtonClickEvent(event, {
      productArea,
      source: PROGRESSIVE_ONBOARDING_SOURCE,
      workflow,
      step,
      shop_id: user.shop_id,
    });
  };

  return (
    <button className={classes.container} onClick={handleClick} type="button">
      <div className={classes.content}>
        <div>
          <Icon component={IconSet.Award} color="var(--highlight-color)" />
        </div>
        <div className={classes.text}>
          <Heading size="xx-small">Try It Yourself</Heading>
          <BodyText className={classes.message}>{message}</BodyText>
        </div>
        <div className={classes.arrow}>
          <Icon
            component={IconSet.ArrowRight}
            color="var(--border-color-dim)"
            size={24}
          />
        </div>
      </div>
    </button>
  );
};
